import { type FolderApi, Pane } from 'tweakpane';
import type { BaseCondition, OfferDefinition, OfferSystemConfig } from '../offerSystemTypes';
import { createListHandlerWithOptions } from './utils/createListHandlerWithOptions';
import { createListHandler } from './utils/createListHandler';

export class OfferEditorOfferMenu<S, C extends BaseCondition, GD> {
  public readonly element: HTMLDivElement = document.createElement('div');

  private pane: Pane | null = null;

  constructor(private readonly config: OfferSystemConfig<S, C, GD>) {
    Object.assign(this.element.style, {
      position: 'fixed',
      top: '0',
      bottom: '0',
      overflowY: 'scroll',
      right: '0',
    });
    document.body.appendChild(this.element);
  }

  public editOffer(offer: OfferDefinition<C, GD> | null): void {
    this.clear();
    if (!offer) return;
    this.createMenu(offer);
  }

  private createMenu(offer: OfferDefinition<C, GD>): void {
    const pane = new Pane();
    this.pane = pane;

    this.element.appendChild(pane.element);

    pane.addBinding(offer, 'id', { label: 'Offer id' });
    this.createOfferLocalizedMenu(pane.addFolder({ title: 'Display Name', expanded: false }), offer, 'displayName');
    createListHandlerWithOptions(
      pane.addFolder({ title: 'Location', expanded: false }),
      offer.location,
      this.config.locations,
    );
    createListHandlerWithOptions(
      pane.addFolder({ title: 'Trigger', expanded: false }),
      offer.triggers,
      this.config.triggers,
    );

    createListHandler(pane.addFolder({ title: 'Tags', expanded: false }), offer.tags, 'string');

    // void new ConditionMenu({
    //   rootFolder: pane.addFolder({ title: 'Start Conditions', expanded: true }),
    //   conditionGroups: offer.startConditions,
    //   systemConfig: this.config,
    // });
    //
    // void new ConditionMenu({
    //   rootFolder: pane.addFolder({ title: 'End Conditions', expanded: true }),
    //   conditionGroups: offer.endConditions,
    //   systemConfig: this.config,
    // });

    // time
    pane.addBinding(offer, 'priority', { label: 'Priority', step: 1 });
    // content

    pane
      .addButton({
        title: 'Save',
      })
      .on('click', () => {
        pane.dispose();
      });

    pane
      .addButton({
        title: 'Close',
      })
      .on('click', () => {
        this.clear();
      });
  }

  private createOfferLocalizedMenu(folderApi: FolderApi, target: OfferDefinition<C, GD>, key: 'displayName'): void {
    const temp = {
      active: target[key] !== null,
      values: target[key] ?? Object.fromEntries(this.config.supportedLanguages.map((v) => [v, ''])),
    };

    folderApi.addBinding(temp, 'active', { label: 'Active' }).on('change', (event) => {
      if (event.value) {
        target[key] = temp.values;
      } else {
        target[key] = null;
      }
    });

    Object.keys(temp.values).forEach((langKey) => {
      folderApi.addBinding(temp.values, langKey);
    });
  }

  private clear(): void {
    this.pane?.dispose();
    this.pane = null;
  }
}
